import * as React from 'react';
import { reduxForm } from 'redux-form';
import { AgreementPageWithFormProps } from '../ClientAgreement';
import ContentContainer, { formSelector } from '../ContentContainer/Content';
import { connect } from 'react-redux';
import agreementStyles from '../ClientAgreement.module.css';

const AgreementPage6 = (props: AgreementPageWithFormProps) => (
  <ContentContainer {...props} requiredSignatures="none" currentPage={6} noScroll>
    <div className={agreementStyles.contentHeader}>
      Exhibit 3<br />
      Dispute Resolution by Binding Arbitration
      <br />
      <br />
    </div>
    <b>Notice Requirement:</b> Prior to initiating any litigation relating to this Agreement, the
    Parties agree to provide ninety (90) days written notice and a reasonable opportunity to cure
    any alleged breach or default of this Agreement. Such notice shall specify in reasonable detail
    the nature of the alleged breach or default and any supporting facts. Notice shall be provided
    in writing and delivered via certified mail, return receipt requested and via email.
    <br />
    <p style={{ paddingLeft: '.5in' }}>
      Notice to Ascend shall be sent to: Ascend Debt Relief PLLC, 90 Great Oaks Boulevard, Suite
      204, San Jose, California 95119 to ds@ascenddebtrelief.com.
      <br />
      Notice to Client shall be sent to the most recent mailing address and email on file for the
      Client.
    </p>
    <b>Waiver of Jury Trial</b>: The Parties acknowledge and agree that any controversy that may
    arise under or relate to this Agreement is likely to involve complicated and difficult issues
    and therefore, the Parties irrevocably and unconditionally waive any right it may have to a
    trial by jury in respect to any legal action that may arise under or relate to this Agreement.
    <br />
    <b>Mediation</b>: Client agrees that before bringing any proceeding that may arise under or
    relate to this Agreement, Client is required to submit to mediation in Phoenix, Arizona to
    attempt to resolve any dispute between the Parties before initiating any proceeding. The costs
    of any such mediation shall be shared equally by the Parties. Failure to follow this mandatory
    mediation clause will result in any costs, including attorneys’ fees, that are necessary to
    defend Ascend being assessed against Client.
    <br />
    <b>Binding Arbitration</b>: Any dispute arising out of or in connection with this Agreement,
    including any question regarding its existence, validity or termination, shall be referred to
    and finally resolved by arbitration under the Rules of Arbitration of the American Arbitration
    Association by one or more arbitrators appointed in accordance with the said Rules.
    <p style={{ paddingLeft: '.5in' }}>The place of arbitration shall be Phoenix, Arizona.</p>
    <b>Cost of Arbitration</b>: The costs of any such mediation shall be shared equally by the
    Parties.
  </ContentContainer>
);

const form = reduxForm({
  form: 'clientAgreement',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(AgreementPage6 as any);

export default connect((state) => ({
  name: formSelector(state, 'name'),
}))(form) as any;
